import React from "react";
import {  Link, NavLink } from "react-router";
 //import { NavLink } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "../../../App.css";
import HomeIcon from "../template/icons/HomeIcon"
import ComplianceIcon from "../template/icons/ComplianceIcon"
import UxIcon from "../template/icons/UxIcon"
import CoursesIcon from "../template/icons/CoursesIcon"
import LoginIcon from "../template/icons/LoginIcon"
import TasksIcon from "./icons/TasksIcon";

import { useAuth } from "../../../context/AuthContext"; 



const NavBottom = () => {

    // 3. Extraemos el usuario actual directamente desde el Contexto de React
  const { user } = useAuth(); 
  
  // 4. Si el objeto 'user' existe en el contexto, significa que está logueado
  const isLoggedIn = !!user;  

  //HERE YOU CAN CHANGE THE ICONS AND LINKS COLORS AND HOVERS
const linkClass = `m-1 hover:text-slate-600 focus:text-slate-400 text-blue-500 text-center drop-shadow-sm`;
const linkClassActive = `m-1 text-lime-500 hover:text-slate-600 text-center drop-shadow-md`;
//const user = AuthService.getCurrentUser();

  return (
       
      <nav id="responsive-bottom-nav" 
            className="w-full mt-4 mb-3 content-start h-fit  bg-white  md:hidden fixed bottom-12 right-0  z-30 px-4 ">

          <div className=" flex flex-row justify-between font-light text-xs ">
            
              <NavLink to={"/home"} className={({ isActive }) => (isActive ? linkClassActive : linkClass)}>
                <HomeIcon/>
                Home
              </NavLink>
            
              {isLoggedIn ? (
            
                <>
                {//senecesita confs y uCOnfs por que tienen diferente enfoque, el primero es a nivel de or, el segundo a nivel de user, sin embargo para que se muestre una opcion ambas deben cumplirse

                parseInt(user.confs?.is_module_evals, 10) && parseInt(user.uConfs?.is_module_evals, 10) ? (
                  <NavLink to={"/mycompliance"} className={({ isActive }) => (isActive ? linkClassActive : linkClass)}>
                    <ComplianceIcon/>
                    Compliance
                  </NavLink>
                
                ) : ('')
                }
                {parseInt(user.confs?.is_module_ux, 10) && parseInt(user.uConfs?.is_module_ux, 10) ? (  
                  <NavLink to={"/myuserx"} className={({ isActive }) => (isActive ? linkClassActive : linkClass)}>
                    <UxIcon/>
                    UX
                  </NavLink>
                ) : ('')
                }
                {parseInt(user.confs?.is_module_tasks, 10) && parseInt(user.uConfs?.is_module_tasks, 10) ? (  

                  <NavLink to={"/mytasks"} className={({ isActive }) => (isActive ? linkClassActive : linkClass)}>
                    <TasksIcon/>
                    Tasks
                  </NavLink>
                ) : ('')
                }  
                {parseInt(user.confs?.is_module_courses, 10) && parseInt(user.uConfs?.is_module_courses, 10) ? (  
                  <NavLink to={"/mycourses"} className={({ isActive }) => (isActive ? linkClassActive : linkClass)}>
                    <CoursesIcon/>
                    Courses
                  </NavLink>
                ) : ('')
                }
                  
                  
                
                  {/*
                  <li className="nav-item">
                    <a href="/logout" className="nav-link" onClick={logOut}>
                      LogOut
                    </a>
                  </li>


                */}
                
                  

                  <div className="absolute group right-3 bottom-16 w-fit z-50 items-center">
                    <NavLink to={"/profile"} className={`w-full h-full group-hover:no-underline`}>
                      <div className={`${user.gender === 'male' ? 'bg-teal-600' : user.gender === 'female' ? 'bg-pink-500' : 'bg-purple-600'} rounded-full shadow-md group-hover:shadow-lg w-8 h-8 ring ring-neutral-100 group-hover:ring-white  transition group-hover:scale-110  overflow-hidden `}>
                      <span className="font-extrabold text-xl text-center text-neutral-100 group-hover:text-white">
                                                {user.fullname.trim()                 // Remove trailing or leading spaces
                                                .split(/\s+/)           // Split by any number of spaces
                                                .map(word => word[0])   // Take the first letter of each word
                                                .join('')               // Join them into one string
                                                .toUpperCase()}
                      </span>
                      {/*<UserIcon className="absolute inset-0 opacity-25" iconClassName="absolute w-9 h-9" />*/}
                      </div>                            
                    </NavLink>
                  </div>
              

                </>  


              ) : (
                <>
              
                  <NavLink to={"/login"} className={` `+linkClass}>
                    <LoginIcon/>
                    Login
                  </NavLink>
                

                
                  
              
                </>
              )}

              
          
          </div>
          
      
      </nav>

      
      
      
    
  );
};

export default NavBottom;
